module.exports = __webpack_public_path__ + "img/UpstreamNZ-Badge-03.4d980e7b.png";